if (!customElements.get('dt-faq-item')) {
  customElements.define('dt-faq-item', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const button = this.querySelector('button');
      const panel = this.querySelector('[data-faq-answer]');
      if (!button || !panel) return;
      this.dataset.ready = 'true';
      button.disabled = false;
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      });
    }
  });
}
